import {Item} from '../../models/Item';
import {AbstractMainPlugin} from '../AbstractMainPlugin';
import {ObjectConfig} from '../../models/ObjectConfig';


export class CrowdLevelPlugin extends AbstractMainPlugin {

  constructor(item: Item) {
    super(item);

    this.initListeners();
  }

  private assignInput(){
    const input = {
      label: 'Crowd Level API',
      value: '',
      type: 'text'
    };
    this.item.config.assignInput('crowd_level_endpoint', input);
  }

  private assignCapacityInput(){
    const input = {
      label: 'Max Crowd Capacity',
      value: '',
      type: 'number'
    };
    this.item.config.assignInput('crowd_level_capacity', input);
  }

  private assignCameraInput(){
    const input = {
      label: 'Has Camera',
      value: 'No',
      options: [{label: 'Oui', value: 'Yes'},{label: 'Non', value: 'No'}]
    };
    this.item.config.assignInput('crowd_level_has_camera', input);
  }

  private initListeners() {
    let input = this.item.config.getInputByName('crowd_level_endpoint');
    if (!input) {
      if (this.item.config.getTool().has_crowd_level) {
        this.assignInput();
      }
    }
    input = this.item.config.getInputByName('crowd_level_capacity');
    if (!input) {
      if (this.item.config.getTool().has_crowd_level) {
        this.assignCapacityInput();
      }
    }
    input = this.item.config.getInputByName('crowd_level_has_camera');
    if (!input) {
      if (this.item.config.getTool().has_crowd_level) {
        this.assignCameraInput();
      }
    }
  }

}
